<template>
    <div :id="popupId" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h2><img src="/img/Alerts/plusbig_icon.png" /> Task</h2>
                    <button ref="popupCloseButton" type="button" class="close" data-dismiss="modal" aria-label="Close">
                    </button>
                </div>
                <div class="modal-body">
                    <form v-on:submit.prevent="addTask" data-vv-scope="add-task">
                      <div class="row">
                          <div class="col-sm-9">
                            <h3>Task Name</h3>
                            <input type="text" placeholder="Task Name" name="name" v-model="taskDetails.name" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('add-task.name') }" />
                          </div>
                          <div class="col-sm-3">
                            <h3>Order</h3>
                            <input type="text" placeholder="Task Name" name="order" v-model="taskDetails.order" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('add-task.order') }" />
                          </div>
                          <div class="col-sm-12">
                            <h3>Tags</h3>
                            <multiselect
                              v-model="taskDetails.tags"
                              :options="tags"
                              :multiple="true"
                              :close-on-select="false"
                              :clear-on-select="false"
                              :preserve-search="true"
                              placeholder="Select Tags"
                              :taggable="true"
                              @tag="addTag"
                            ></multiselect>
                          </div>
                          <div class="col-sm-12">
                            <h3>Add Task Image</h3>
                            <div class="image-upload">
                              <croppa v-model="myCroppa"
                                  :width="400"
                                  :height="500"
                                  placeholder="Choose a task image"
                                  initial-size="contain"
                                  :placeholder-font-size="16"
                                  :show-remove-button="false"
                                  @file-choose="CropEnable"
                                  @image-remove="cropDisable"
                                  @move="CropEnable"
                                  @zoom="CropEnable"
                                  @new-image-drawn="generateImage"
                                  :initial-image="currentImage"
                              ></croppa>

                              <input type="hidden" name="image" v-model="taskDetails.image" v-validate="'required'" /><br />
                              <span class="error-msg" v-show="errors.has('add-task.image')">{{ errors.first('add-task.image') }}</span><br/>
                              <button v-if="taskDetails.image" class="btn-negative" type="button" @click="myCroppa.remove()">Remove</button>
                              <button v-else class="btn-positive uploadButton" type="button" @click="generateImage" :disabled="!imageSelected">Crop</button>
                            </div>
                          </div>
                        </div>
                       <input type="submit" class="btn-lg-green" :value="editTaskFlag ? 'UPDATE' : 'ADD' + ' TASK'" :disabled="submittingForm" />
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

export default {
  name: 'TaskPopup',
  props: ['popupId', 'taskDetails', 'editTaskFlag'],
  components: {
    Multiselect
  },
  data: function () {
    return {
      tags: [
        'Dining',
        'Entertainment',
        'Events',
        'Hospitality',
        'Retail'
      ],
      myCroppa: {},
      submittingForm: false,
      imageSelected: false,
      currentImage: ''
    }
  },
  methods: {
    addTask () {
      this.$validator.validateAll('add-task').then((result) => {
        if (result) {
          this.submittingForm = true
          let action = 'addTask'
          let message = 'added'
          if (this.editTaskFlag) {
            action = 'editTask'
            message = 'updated'
          }
          this.$store.dispatch(action, this.taskDetails).then(() => {
            this.$refs.popupCloseButton.click()
            this.resetForm()
            this.$notify({ type: 'success', text: 'Task has been ' + message + ' successfully' })
            this.submittingForm = false
            this.$emit('updateTasksList')
          }, (response) => {
            for (var key in response.body) {
              this.$notify({ type: 'error', text: response.body[key][0] })
              let field = this.$validator.fields.find({ name: key, scope: 'add-task' })

              if (field) {
                this.$validator.errors.add({
                  id: field.id,
                  field: key,
                  msg: response.body[key][0],
                  scope: 'add-task'
                })

                field.setFlags({
                  invalid: true,
                  valid: false,
                  validated: true
                })
              }
            }
            this.errorMessage = response.body.message
            this.submittingForm = false
          })
        } else {
          if (this.errors.has('add-task.password:min')) {
            this.$notify({ type: 'error', text: 'Password should be at least 6 letters' })
          } else if (this.errors.has('add-task.contact_mobile:regex')) {
            this.$notify({ type: 'error', text: 'Please enter a valid mobile number' })
          } else {
            this.$notify({ type: 'error', text: 'Please fill out all the required fields' })
          }
        }
      })
    },
    generateImage () {
      let url = this.myCroppa.generateDataUrl()
      if (!url) {
        return
      }

      this.taskDetails.image = url
    },
    CropEnable () {
      this.taskDetails.image = ''
      this.imageSelected = true
    },
    cropDisable () {
      this.taskDetails.image = ''
      this.imageSelected = false
    },
    resetForm () {
      this.myCroppa.remove()
      let myCroppa = this.myCroppa
      Object.assign(this.$data, this.$options.data.apply(this))
      this.myCroppa = myCroppa
      this.errors.clear('add-task')
    },
    addTag (newTag) {
      this.tags.push(newTag)
      this.taskDetails.tags.push(newTag)
    }
  },
  watch: {
    taskDetails () {
      console.log(this.taskDetails)
      this.myCroppa.refresh()
      this.currentImage = this.taskDetails.image + '?w=400'
    }
  }
}
</script>

<style scoped>
.btn-negative {
  font-size: 15px;
  font-weight: 400;
  margin-top: 0;
}

.image-upload {
  display: inline-block;
  width: auto;
  text-align: center;
}
</style>
